/**
 * AutoGenerateButton Component
 * 
 * A reusable button component for auto-generating IDs or other values.
 * Used in forms where users can either manually enter a value or auto-generate it.
 * 
 * Design Principles:
 * - Clean, minimal button design
 * - Consistent with form styling
 * - Clear visual indication of action
 */

import React from 'react';
import './AutoGenerateButton.css';

export interface AutoGenerateButtonProps {
  /** Click handler for auto-generation */
  onClick: () => void;
  /** Button text (default: "Auto-Generate") */
  label?: string;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Additional CSS class name */
  className?: string;
}

const AutoGenerateButton: React.FC<AutoGenerateButtonProps> = ({
  onClick,
  label = 'Auto-Generate',
  disabled = false,
  className = '',
}) => {
  return (
    <button
      type="button"
      className={`auto-generate-button ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      {label}
    </button>
  );
};

export default AutoGenerateButton;

